import { netDiffOpenConversationsGauge } from 'ducks/reports/gauges'
import { HeadlineVisualization } from 'ducks/reports/visualizations'

const staticProps = {
  diff: true,
  gauges: [netDiffOpenConversationsGauge],
  isNegativeGood: true,
  massive: true,
  suffix: 'change in opened conversations',
  title: 'Opened vs Closed',
}

export default function NetDiffOpenConversations(props) {
  return <HeadlineVisualization {...props} {...staticProps} />
}
